/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_A8Inputs */

const en_fc_home_faq_a8 = /** @type {(inputs: Fc_Home_Faq_A8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The source lives at github.com/storytold/filmcraft. Releases, issue tracking and the full README with supported formats and shortcuts are all there.`)
};

/**
* | output |
* | --- |
* | "The source lives at github.com/storytold/filmcraft. Releases, issue tracking and the full README with supported formats and shortcuts are all there." |
*
* @param {Fc_Home_Faq_A8Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_a8 = /** @type {((inputs?: Fc_Home_Faq_A8Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_A8Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_a8(inputs)
});
export { fc_home_faq_a8 as "fc.home.faq.a8" }